/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// utils
import {
    formatNumber,
    getChangeRateDirection,
    getEnabledRollUps,
    formatTableDate,
    formatCommentingReportDates
} from '../../../../../utils/charts';
// material
import TableReportSection from "../../../../../material/tablereportsection/tablereportsection";
// styles
import injectSheet from 'react-jss';
import styles from './topskippedreport_style';



/* ========== ~~~~~~~~~~ TRIVIA ANALYTICS - TOP SKIPPED REPORT ~~~~~~~~~~ ========== */
const TopSkippedReport = injectSheet(styles)((props) => {

    // todo replace with correct api call
    const {data, status} = useSelector((state) => state.triviaAndPolls.topSkippedCards);

    const columns = [
        {
            key: 'rank',
            title: 'Rank'
        },
        {
            key: 'topQuestions',
            title: 'Trivia question'
        },
        {
            key: 'skips',
            title: 'Skips',
            format: 'comma'
        },
        {
            key: 'skipPercentage',
            title: 'Skip percentage',
            format: 'percent'
        }
    ];
    const exportDataConfig = {
        fileName: 'top_skipped_cards',
        excludedColumns: ['embed_uuid', '']
    };
    const exportAllDataConfig = {
        onClick: props.onExportAllClick
    }
    return (
        <div name={'topskippedreport'} klass={`${props.classes.skipped}`} >
            <TableReportSection
                title={'Top Skipped Cards'}
                columns={columns}
                data={data.slice(0, 20)}
                rowsPerPage={10}
                exportData={exportDataConfig}
                exportAll={exportAllDataConfig}
                loading={status === 'pending'}
                tooltipContent={
                    <div className={'tip-content'}>
                        <div className={'tip-title'}>
                            <h4>Top Skipped Cards</h4>
                        </div>
                        <div className={'tip-desc'}>
                            <p>
                                Shows the top 50 least popular cards based on the number of skips. Each card will also show the skip percentage which is calculated by taking the total skips and dividing by the total number of responses AND skips (total clicks)
                            </p>
                        </div>
                    </div>
                }
            />
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TopSkippedReport;
